import axios from "axios";
import { config } from "../../Network_Calls/config";

const postDossierDetails = async (implId, id, dossierDetails) => {

  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/postDossierDetails",
    {
      implId:implId,
      id:id,
      dossierDetails: dossierDetails,
    },
    {
      ...config(),
    }
  );
  return response;
};

const getDossierDetails = async (implId, id) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/getDossierDetails",
    {
      implId:implId,
      id:id
    },
    {
      ...config(),
    }
  );
  return response;
};


const deleteKeyDetail = async ({ id }) => {
  const response = await axios.delete(
    process.env.REACT_APP_SERVER_URL + "/dossier/deleteKeyDetails",
    {
      ...config(),
      data: {id}
    }
  );
  return response;
};

const postDossierActionPlan = async (actionPlans, dossierId, external_id) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/postDossierActionPlan",
    {
      actionPlan: actionPlans, 
      dossierId: dossierId,
      external_id:external_id
    },
    {
      ...config(),
    }
  );
  return response;
};

const getDossierActionPlan = async (dossierId) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/getDossierActionPlan",
    {
      dossierId: dossierId
    },
    {
      ...config(),
    }
  );
  return response;
};

const deleteActionPlan = async ( id ) => {
  const response = await axios.delete(
    process.env.REACT_APP_SERVER_URL + "/dossier/deleteActionPlan",
    {
      ...config(),
      data: {id}
    }
  );
  return response;
};

const getDossierTagUsersList = async (implId) => {

  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/getDossierTagUsersList",
    {
      implId:implId
    },
    {
      ...config(),
    }
  );
  return response;
};

const linkVisitHistoryUpdate = async (id) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/linkVisitHistoryUpdate",
    {
      linkId:id,
      event:"Dossier Link"
    },
    {
      ...config(),
    }
  );
  return response;
};

const linkTagMembersFetch = async (id) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/dossier/linkTagMembersFetch",
    {
      implId:id
    },
    {
      ...config(),
    }
  );
  return response;
};



export {
    postDossierDetails,
    getDossierDetails,
    deleteKeyDetail,
    postDossierActionPlan,
    getDossierActionPlan,
    deleteActionPlan,
    getDossierTagUsersList,
    linkVisitHistoryUpdate,
    linkTagMembersFetch,
    
}